import React, { useState } from "react";
import { fmtHour, slotCfg } from "../bookingService";

function HourSelect({ value, onChange, max }) {
    const opts = [];
    for (let h = 0; h <= (max ?? 23); h++) opts.push(h);
    return (
        <select className="hk-select" value={value} onChange={(e) => onChange(parseInt(e.target.value, 10))}>
            {opts.map((h) => (
                <option key={h} value={h}>{fmtHour(h)}</option>
            ))}
        </select>
    );
}

/**
 * Scheduling settings for one resource-type calendar:
 * name, resource label, slot length, opening hours, minimum notice,
 * and how far ahead customers can book.
 */
export default function TypeSettingsForm({ type, onSave, saving }) {
    const cfg = slotCfg(type);
    const [name, setName] = useState(type.name || "");
    const [label, setLabel] = useState(type.resourceLabel || "");
    const [slotMin, setSlotMin] = useState(cfg.slotMin);
    const [dayStart, setDayStart] = useState(cfg.dayStart);
    const [dayEnd, setDayEnd] = useState(cfg.dayEnd);
    const [leadMin, setLeadMin] = useState(cfg.leadMin);
    const [advanceDays, setAdvanceDays] = useState(cfg.advanceDays);
    const [formError, setFormError] = useState("");

    const handleSave = () => {
        if (!name.trim()) {
            setFormError("Calendar name is required.");
            return;
        }
        if (!label.trim()) {
            setFormError("Resource label is required.");
            return;
        }
        if (dayEnd <= dayStart) {
            setFormError("Closing hour must be after opening hour.");
            return;
        }
        setFormError("");
        onSave({
            name: name.trim(),
            resourceLabel: label.trim(),
            slotMin: Math.max(5, parseInt(slotMin, 10) || 30),
            dayStart,
            dayEnd,
            leadMin: Math.max(0, parseInt(leadMin, 10) || 0),
            advanceDays: Math.max(1, parseInt(advanceDays, 10) || 30),
        });
    };

    return (
        <div className="p-4 rounded-2xl bg-[#f8fafc] border border-[#e2e8f0] space-y-3">
            {formError && <div className="alert alert-danger py-2 mb-0">{formError}</div>}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                <div>
                    <label className="hk-label">Calendar name</label>
                    <input className="hk-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="Dining Tables" />
                </div>
                <div>
                    <label className="hk-label">Resource label</label>
                    <input className="hk-input" value={label} onChange={(e) => setLabel(e.target.value)} placeholder="Table, Doctor, Mat…" />
                </div>
                <div>
                    <label className="hk-label">Slot length (minutes)</label>
                    <input className="hk-input" type="number" min="5" step="5" value={slotMin} onChange={(e) => setSlotMin(e.target.value)} />
                </div>
                <div>
                    <label className="hk-label">Minimum notice (minutes)</label>
                    <input className="hk-input" type="number" min="0" step="5" value={leadMin} onChange={(e) => setLeadMin(e.target.value)} title="How far ahead customers must book" />
                </div>
                <div>
                    <label className="hk-label">Opens</label>
                    <HourSelect value={dayStart} onChange={setDayStart} />
                </div>
                <div>
                    <label className="hk-label">Closes</label>
                    <HourSelect value={dayEnd} onChange={setDayEnd} max={24} />
                </div>
                <div className="sm:col-span-2">
                    <label className="hk-label">Bookable window (days ahead)</label>
                    <input className="hk-input" type="number" min="1" value={advanceDays} onChange={(e) => setAdvanceDays(e.target.value)} />
                </div>
            </div>
            <div className="flex justify-end">
                <button className="hk-btn hk-btn-primary hk-btn-sm" disabled={!!saving} onClick={handleSave}>
                    {saving ? "Saving…" : "Save settings"}
                </button>
            </div>
        </div>
    );
}
